import { TabModel } from "./tabmodel";
import styles from './Tabbar.module.css'
import iconMain from './image/icon_main.svg'
import iconChat from './image/icon _ chat.svg'
import iconProfile from './image/icon _ profile.svg'
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { MainIcon } from "./icons/MainIcon";
import { ChatIcon } from "./icons/ChatIcon";
import { ProfileIcon } from "./icons/ProfileIcon";
import { RaitingIcon } from "./icons/RaitingIcon";
export const Tabbar = ({isBottomMenu}:{isBottomMenu:boolean}) =>{
    const tabbarArr:TabModel[] = [
        {img:<MainIcon color="#CCCCCC"/>, imgActive:<MainIcon color="#50964E"/>, path:"*",text:"Главная", isActive:true, id:0},
        {img:<RaitingIcon color="#CCCCCC"/>, imgActive:<RaitingIcon color="#50964E"/>, path:"/raiting",text:"Рейтинг", isActive:false, id:3},
        {img:<ChatIcon color="#CCCCCC"/>, imgActive:<ChatIcon color="#50964E"/>, path:"/lenta",text:"Лента", isActive:false, id:1},
        {img:<ProfileIcon color="#CCCCCC"/>, imgActive:<ProfileIcon color="#50964E"/>, path:"/profile",text:"Профиль", isActive:false, id:2}
    ];
    const [tabsArr,setTabsArr] = useState(tabbarArr)
    const [activeId,setActiveId]=useState(0)
    const navigation = useNavigate();

    const setActiveTab=(id:number)=>{
        tabbarArr.forEach((item)=>{
            if(item.id===id){
                item.isActive=true;
                navigation(item.path)
            }else{
                item.isActive=false
            }
        })
        setTabsArr(tabbarArr)
        
    }
    
    return(
        <div className={styles.tabbar} style={{display:isBottomMenu==true?"flex":"none"}}>
            <div className={styles.tabbar_content}>
                {tabsArr.map((item,key)=>{
                    return(
                        <div className={styles.tarbar_item} onClick={()=>setActiveTab(item.id)}>
                            <div className={styles.iconfont}>
                                {item.isActive?item.imgActive:item.img}
                            </div>
                            <div style={{color:item.isActive?"#000000":"#CCCCCC"}}>{item.text}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}